import PropTypes from "prop-types";
import {
  SkeletonItem,
  SkeletonLine,
  SkeletonText,
  SkeletonThumb,
} from "./SearchListSkeleton.styles";

export const SearchListSkeleton = ({ count, type }) => {
  return Array.from({ length: count }).map((_, index) => (
    <SkeletonItem className="search-item" key={`${type}-${index}`}>
      <SkeletonThumb className="placeholder-glow">
        <span className="placeholder" />
      </SkeletonThumb>
      <SkeletonText className="placeholder-glow">
        <SkeletonLine className="placeholder" />
      </SkeletonText>
    </SkeletonItem>
  ));
};

SearchListSkeleton.propTypes = {
  count: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
};
